import { defineComponent } from "vue";
import BaseModal from "@/components/Shared/Modals/BaseModal/BaseModal.vue";
import ErrorTestC from "@/assets/covid/error-test-c.svg";
import ErrorTestT from "@/assets/covid/error-test-t.svg";

export default defineComponent({
  components: {
    BaseModal,
  },
  data() {
    return {
      isActive: false,
      errorTestCimage: ErrorTestC,
      errorTestTimage: ErrorTestT,
    };
  },
  methods: {
    toggleModal(status: boolean) {
      const el: any = this.$refs["base-modal"];
      el.toggleBaseModal(status);
    },
  },
});
